<template>
  <div class="place-items-center p-email-input">
    <div class="p-email-input__wrapper">
      <p-text-input
        v-model="emailAutoComplete"
        :name="name"
        type="text"
        :label="label"
        :error="props.error"
        show-clear
        :placeholder="placeholder"
        @on-input="handleInput"
      />
      <div v-if="showSuggestions" class="p-menu">
        <div
          v-for="email in filteredEmails"
          :key="email"
          class="p-menu__item"
          @click="itemClickHandler({ value: email })"
        >
          <div class="p-email-input__item">
            <span class="p-email-input__value">{{ emailAutoComplete }}</span
            ><span class="t-fg-primary">{{ email.replace(emailAutoComplete, '') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const providers = ['gmail.com', 'hotmail.com', 'icloud.com', 'outlook.com', 'yahoo.com']
const showSuggestions = ref(false)

const props = defineProps({
  name: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: Boolean,
    default: false,
  },
})

const emailAutoComplete = defineModel<string>('modelValue', { default: '' })

const filteredEmails = computed<string[]>(() => {
  if (!emailAutoComplete.value.includes('@')) {
    return providers.map((provider) => `${emailAutoComplete.value}@${provider}`)
  }
  return []
})

const handleInput = () => {
  showSuggestions.value =
    emailAutoComplete.value.length >= 3 && !emailAutoComplete.value.includes('@')
}

const itemClickHandler = (item: { value: string }) => {
  emailAutoComplete.value = item.value
  showSuggestions.value = false
}
</script>
